export class ArrayHelper {
  public static toMap<T>(arr, keyFct: Function): Map<string, T> {
    return new Map(arr.map(i => [keyFct(i), i]));
  }
}
